<template>
  <span>
    <img draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 3.png" alt="">

    <span v-show="$store.getters['app/overlays'].show_game_overlay">
      <img draggable="false" id="gezond_lichaam_img_2" src="./../assets/images/Asset 2.png" alt="">
      <img draggable="false" id="person_img_2" src="./../assets/images/Asset 1.png" alt="">

      <div class="game_container">
        <span v-for="(klontje) in klontjes" :key="klontje.id">
          <img v-if="klontje.id == 1" draggable="true" v-on:dragstart="drag($event)" class="klontje__" id="klontje__1" src="./../assets/images/Asset 21.png" alt="">
          <img v-if="klontje.id == 2" draggable="true" v-on:dragstart="drag($event)" class="klontje__" id="klontje__2" src="./../assets/images/Asset 22.png" alt="">
          <img v-if="klontje.id == 3" draggable="true" v-on:dragstart="drag($event)" class="klontje__" id="klontje__3" src="./../assets/images/Asset 23.png" alt="">
          <img v-if="klontje.id == 4" draggable="true" v-on:dragstart="drag($event)" class="klontje__" id="klontje__4" src="./../assets/images/Asset 24.png" alt="">
          <img v-if="klontje.id == 5" draggable="true" v-on:dragstart="drag($event)" class="klontje__" id="klontje__5" src="./../assets/images/Asset 25.png" alt="">
        </span>
        <div>
          <img draggable="false" v-on:drop="drop($event, 1)" v-on:dragover="allowDrop($event)" id="product_1" src="./../assets/images/Asset 20_2.png" alt="">
          <img draggable="false" v-on:drop="drop($event, 2)" v-on:dragover="allowDrop($event)" id="product_2" src="./../assets/images/Asset 11.png" alt="">
          <img draggable="false" v-on:drop="drop($event, 3)" v-on:dragover="allowDrop($event)" id="product_3" src="./../assets/images/Asset 9.png" alt="">
          <img draggable="false" v-on:drop="drop($event, 4)" v-on:dragover="allowDrop($event)" id="product_4" src="./../assets/images/Asset 10.png" alt="">
          <img draggable="false" v-on:drop="drop($event, 5)" v-on:dragover="allowDrop($event)" id="product_5" src="./../assets/images/Asset 19.png" alt="">
        </div>

        <div>
          <span id="bar_1"></span>
          <span id="bar_progress_1"></span>
          <span id="bar_2"></span>
          <span id="bar_progress_2"></span>
          <span id="bar_3"></span>
          <span id="bar_progress_3"></span>
          <span id="bar_4"></span>
          <span id="bar_progress_4"></span>
          <span id="bar_5"></span>
          <span id="bar_progress_5"></span>
        </div>

        <span v-for="(product) in products" :key="product.id">
          <span :id="`text_bar_${product.id}`"><span v-html="product.gram"></span> gram suiker</span>
        </span>
      </div>
    </span>
  </span>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: "Game",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      klontjes: [
        {
          id: "1",
        },
        {
          id: "2",
        },
        {
          id: "3",
        },
        {
          id: "4",
        },
        {
          id: "5",
        },
      ],
      products: [
        {
          id: 1,
          progress: 100,
          gram: 0,
          max: 50,
          bar_multiplier: 2,
          done: false,
        },
        {
          id: 2,
          progress: 100,
          gram: 0,
          max: 11,
          bar_multiplier: 9.1,
          done: false,
        },
        {
          id: 3,
          progress: 100,
          gram: 0,
          max: 68,
          bar_multiplier: 1.48,
          done: false,
        },
        {
          id: 4,
          progress: 100,
          gram: 0,
          max: 12,
          bar_multiplier: 8.333,
          done: false,
        },
        {
          id: 5,
          progress: 100,
          gram: 0,
          max: 31,
          bar_multiplier: 3.225,
          done: false,
        },
      ]
    };
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToEnd() {
      this.$router.push('/end');
    },
    allowDrop(event) {
      event.preventDefault();
    },

    drag(event) {
      event.dataTransfer.setData("text", event.target.id);
    },

    drop(event, product_id) {
      // TODO: Dropped klontjes verwijderen uit de data state om geheugen vrij te maken

      event.preventDefault();

      var data = event.dataTransfer.getData("text"),
          id = data.replace('klontje__', '');
      event.target.appendChild(document.getElementById(data));

      /**
       * Refill sugar
       */
      let id_to_push = null;
      for (let index = 0; index < this.klontjes.length; index++) {
        const element = this.klontjes[index];
        if ( element.id == id ) {
          id_to_push = id
        }
      }

      if ( id_to_push !== null ) {
        // this.cleanupKlontjes(id_to_push)
        this.klontjes.push({id: id_to_push});
      }
      // End refill

      /**
       * Increase grams
       */
      for (let index = 0; index < this.products.length; index++) {
        if ( this.products[index].id == product_id ) {
          if ( this.products[index].gram <= this.products[index].max - 1 ) {
            this.products[index].gram += 5;

            if ( this.products[index].gram >= this.products[index].max ) {
              this.products[index].gram = this.products[index].max
              this.products[index].done = true
              
              console.log("Log now");
              this.checkIfCompleted()
            }

            let width = (this.products[index].gram * this.products[index].bar_multiplier) * 0.125;
            document.getElementById(`bar_progress_${product_id}`).style.width = `${width}%`

            if ( this.products[index].gram <= this.products[index].max - 0.1 ) {
              document.getElementById(`bar_progress_${product_id}`).style.backgroundColor = '#69a643'
              document.getElementById(`text_bar_${product_id}`).style.color = '#69a643'
            } else {
              document.getElementById(`bar_progress_${product_id}`).style.backgroundColor = '#ef9d21'
              document.getElementById(`text_bar_${product_id}`).style.color = '#ef9d21'
            }
          }
        }
      }
    },

    cleanupKlontjes(id) {
      for (let index = 0; index < this.klontjes.length; index++) {
        if ( this.klontjes[index].id === id ) {
          delete this.klontjes[1];
        }
      }
    },

    checkIfCompleted() {
      let completed_products = 0
      for (let index = 0; index < this.products.length; index++) {
        if ( this.products[index].done == true ) completed_products++
      }
      console.log(completed_products);

      if (completed_products == 5) {
        this.gameEnd()
      }
    },

    gameEnd() {
      var that = this
      new swal({
        allowEscapeKey: false,
        allowOutsideClick: false,
        title: "",
        html: `<p class='swal_html'>Goed zo!</p>`,
        type: "success",
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Ga door!',
        confirmButtonColor: "#9BCB3C",
        confirmButtonText: "Opnieuw spelen",
      }).then(function (confirm) {
        if ( confirm.isConfirmed ) {
          that.goToHome()
        } else {
          that.goToEnd()
        }
      });
    },
  },

  computed: {},

  watch: {
    // products: {
    //   handler: function (products) {
    //     completed_products = 0
    //     for (let index = 0; index < products.length; index++) {
    //       if ( products[index].disabled == true ) completed_products++
    //     }
    //     if (completed_products == 5)
    //       this.endGame()
    //   },
    //   deep: true
    // }
  }
};
</script>

<style>
  @font-face {
    font-family: "LuckiestGuy";
    src: url('./../assets/gezondlichaam/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  .klontje__ {
    position: absolute;
    margin-top: 2%;
    width: 10%;
    cursor: url('./../assets/cursor/grab.png'), default;
  }

  #klontje__1 {
    left: 20%;
  }

  #klontje__2 {
    left: 32%;
  }

  #klontje__3 {
    left: 44%;
  }

  #klontje__4 {
    left: 56%;
  }

  #klontje__5 {
    left: 67%;
  }

  #product_1 {
    position: absolute;
    left: 8%;
    margin-top: 14%;
    width: 8%;
    -webkit-filter: drop-shadow(5px 5px 5px #464646);
    filter: drop-shadow(5px 5px 5px #464646);
  }
  #product_2 {
    left: 29%;
    position: absolute;
    margin-top: 22.5%;
    width: 8%;
    -webkit-filter: drop-shadow(5px 5px 5px #464646);
    filter: drop-shadow(5px 5px 5px #464646);
  }
  #product_3 {
    left: 49%;
    position: absolute;
    margin-top: 22%;
    width: 8%;
    -webkit-filter: drop-shadow(5px 5px 5px #464646);
    filter: drop-shadow(5px 5px 5px #464646);
  }
  #product_4 {
    left: 66%;
    position: absolute;
    margin-top: 22%;
    width: 11%;
    -webkit-filter: drop-shadow(5px 3px 5px #464646);
    filter: drop-shadow(5px 3px 5px #464646);
  }
  #product_5 {
    left: 85%;
    position: absolute;
    margin-top: 22%;
    width: 9%;
    -webkit-filter: drop-shadow(5px 5px 5px #464646);
    filter: drop-shadow(5px 5px 5px #464646);
  }

  #bar_1 {
    position: absolute;
    width: 12.5%;
    height: 10%;
    background-color: white;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 6%;
    margin-top: 40%;
  }

  #bar_progress_1 {
    position: absolute;
    width: 0%;
    height: 10%;
    background-color: #69a643;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 6%;
    margin-top: 40%;
  }

  #bar_2 {
    position: absolute;
    width: 12.5%;
    height: 10%;
    background-color: white;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 26%;
    margin-top: 40%;
  }
  
  #bar_progress_2 {
    position: absolute;
    width: 0%;
    height: 10%;
    background-color: #ef9d21;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 26%;
    margin-top: 40%;
  }

  #bar_3 {
    position: absolute;
    width: 12.5%;
    height: 10%;
    background-color: white;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 46.5%;
    margin-top: 40%;
  }

  #bar_progress_3 {
    position: absolute;
    width: 0%;
    height: 10%;
    background-color: #69a643;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 46.5%;
    margin-top: 40%;
  }

  #bar_4 {
    position: absolute;
    width: 12.5%;
    height: 10%;
    background-color: white;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 65%;
    margin-top: 40%;
  }

  #bar_progress_4 {
    position: absolute;
    width: 0%;
    height: 10%;
    background-color: #ef9d21;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 65%;
    margin-top: 40%;
  }

  #bar_5 {
    position: absolute;
    width: 12.5%;
    height: 10%;
    background-color: white;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 83%;
    margin-top: 40%;
  }

  #bar_progress_5 {
    position: absolute;
    width: 0%;
    height: 10%;
    background-color: #ef9d21;
    border-radius: 30px;
    box-shadow: 5px 5px 5px 0px grey;
    display: inline-block;
    left: 83%;
    margin-top: 40%;
  }

  #text_bar_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 47.5%;
    left: 6%;
    color: #69a643;
    font-size: 1em;
  }

  #text_bar_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 47.5%;
    left: 26%;
    color: #69a643;
    font-size: 1em;
  }

  #text_bar_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 47.5%;
    left: 46%;
    color: #69a643;
    font-size: 1em;
  }

  #text_bar_4 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 47.5%;
    left: 65%;
    color: #69a643;
    font-size: 1em;
  }

  #text_bar_5 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 47.5%;
    left: 83%;
    color: #69a643;
    font-size: 1em;
  }
</style>


